import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import Message from '../components/Message'

function HomeScreen() {
  const navigate  = useNavigate()
  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  if (!userInfo) {
    return (
      <Container>
        <div className="hero-banner text-center" style={{ padding: '3rem 2rem' }}>
          <i className="fa-solid fa-graduation-cap" style={{ fontSize: '3.5rem', color: 'var(--gold)', marginBottom: '1rem', display: 'block' }}></i>
          <h1 style={{ fontSize: '2.2rem' }}>Series 65 Full Course</h1>
          <p style={{ fontSize: '1.1rem', maxWidth: 500, margin: '0.75rem auto 1.5rem' }}>
            Master every topic. Pass the real exam. Study at your own pace with guided sections and quizzes.
          </p>
          <button className="btn-gold me-3" style={{ fontSize: '1rem', padding: '0.65rem 1.75rem' }} onClick={() => navigate('/login')}>
            <i className="fa-solid fa-right-to-bracket me-2"></i>Login
          </button>
          <button className="btn-navy" style={{ fontSize: '1rem', padding: '0.65rem 1.75rem' }} onClick={() => navigate('/register')}>
            <i className="fa-solid fa-user-plus me-2"></i>Register
          </button>
        </div>

        {/* Feature chips */}
        <Row className="g-3 mt-2">
          {[
            { icon: 'fa-list-check',   label: 'Structured Sections',   desc: 'Unlock each topic in order' },
            { icon: 'fa-pen-to-square',label: 'Section Quizzes',        desc: 'Test your knowledge after each section' },
            { icon: 'fa-chart-bar',    label: 'Score Tracking',         desc: 'Your results saved automatically' },
          ].map((f, i) => (
            <Col key={i} md={4}>
              <div className="stat-chip">
                <div className="stat-icon"><i className={`fa-solid ${f.icon}`}></i></div>
                <div className="stat-number" style={{ fontSize: '1rem', fontWeight: 700 }}>{f.label}</div>
                <div className="stat-label">{f.desc}</div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    )
  }

  return (
    <Container>
      {/* Welcome banner */}
      <div className="hero-banner">
        <h1><i className="fa-solid fa-hand-wave me-2"></i>Welcome back, {userInfo.name}!</h1>
        <p>Pick up where you left off. Your progress is saved.</p>
        <button
          className="btn-gold mt-3"
          style={{ fontSize: '1rem', padding: '0.65rem 1.75rem' }}
          onClick={() => navigate('/course')}
        >
          <i className="fa-solid fa-book-open me-2"></i>Go to Course
        </button>
      </div>

      {/* Stat chips */}
      <Row className="g-3">
        {[
          { icon: 'fa-graduation-cap', number: '1',    label: 'Sections Available' },
          { icon: 'fa-pen-to-square',  number: '10',   label: 'Quiz Questions' },
          { icon: 'fa-trophy',         number: '72%',  label: 'Passing Score' },
        ].map((s, i) => (
          <Col key={i} md={4}>
            <div className="stat-chip">
              <div className="stat-icon"><i className={`fa-solid ${s.icon}`}></i></div>
              <div className="stat-number">{s.number}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default HomeScreen
